import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

/**
 * Toast Controller
 * 
 * Handles individual Bootstrap toast behavior.
 * Use data-toast-auto-show-value="true" to auto-show on connect (for flash messages).
 */
export default class extends Controller {
  static values = {
    autoShow: { type: Boolean, default: false },
    delay: { type: Number, default: 3000 }
  }

  connect() {
    this.toast = new Toast(this.element, {
      autohide: true,
      delay: this.delayValue
    })

    // Auto-show if this is a flash message toast
    if (this.autoShowValue) {
      this.toast.show()
    }

    // Remove from DOM after hidden
    this.element.addEventListener("hidden.bs.toast", () => {
      this.element.remove()
    })
  }

  disconnect() {
    this.toast?.dispose()
  }

  show() {
    this.toast?.show()
  }

  hide() {
    this.toast?.hide()
  }
}
